import en from 'vuetify/es5/locale/en'
import zh from 'vuetify/es5/locale/zh-Hant'

const locales = { en, zh }

export default locales
